<div class="range-datepicker">
    <div class="form-group">
        <div
            class="input-group"
            [ngClass]="{ 'delete-bottom-radius': toggledCalendar }"
        >
            <div class="flex-row" (click)="toggleCalendar()" #datepickerTrigger>
                <div>
                    <img
                        appImageSelector
                        alt="mt-image"
                        imageType="icon"
                        imageKey="calendar"
                    />
                </div>

                <div>
                    <span class="dp">
                        <strong>{{ "since" | lang | uppercase }}</strong
                        >: {{ displayedFromDate }} &nbsp;&nbsp;
                        <strong>{{ "until" | lang | uppercase }}</strong
                        >:
                        <span
                            class="to-date"
                            [attr.data-value]="displayedToDate"
                            [style.visibility]="
                                displayedToDate ? 'visible' : 'hidden'
                            "
                        >
                        </span>
                    </span>
                </div>
            </div>

            <div #datepickerContainer style="display: none">
                <ngb-datepicker
                    #dp
                    (dateSelect)="onDateSelection($event)"
                    [maxDate]="maxDate"
                    [minDate]="minDate"
                    [displayMonths]="2"
                    [dayTemplate]="t"
                    outsideDays="hidden"
                >
                </ngb-datepicker>

                <ng-template #t let-date let-focused="focused">
                    <span
                        class="custom-day"
                        [class.focused]="focused"
                        [class.range]="isRange(date)"
                        [class.faded]="isHovered(date) || isInside(date)"
                        [class.out-ranged]="isOutRanged(date)"
                        [class.last-date]="isLastDate(date)"
                        [class.first-date]="isFirstDate(date)"
                        (mouseenter)="hoveredDate = date"
                        (mouseleave)="hoveredDate = null"
                    >
                        {{ date.day }}
                    </span>
                </ng-template>
            </div>
        </div>
    </div>
</div>
